!function (e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r(require("react")) : "function" == typeof define && define.amd ? define(["react"], r) : "object" == typeof exports ? exports.ReactSimplyTabs = r(require("react")) : e.ReactSimplyTabs = r(e.React);
}(this, function (e) {
  return function (e) {
    var r = {};
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        enumerable: !0,
        get: n
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, r) {
      if (1 & r && (e = t(e)), 8 & r) return e;
      if (4 & r && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (t.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & r && "string" != typeof e) for (var o in e) t.d(n, o, function (r) {
        return e[r];
      }.bind(null, o));
      return n;
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, t.p = "", t(t.s = 4);
  }([function (r, t) {
    r.exports = e;
  }, function (e, r) {
    var t;
    e.exports = function (e, r, n, o) {
      t || (t = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);
      var a = e && e.defaultProps,
        c = arguments.length - 3;
      if (r || 0 === c || (r = {
        children: void 0
      }), 1 === c) r.children = o;else if (c > 1) {
        for (var i = new Array(c), l = 0; l < c; l++) i[l] = arguments[l + 3];
        r.children = i;
      }
      if (r && a) for (var s in a) void 0 === r[s] && (r[s] = a[s]);else r || (r = a || {});
      return {
        $$typeof: t,
        type: e,
        key: void 0 === n ? null : "" + n,
        ref: null,
        props: r,
        _owner: null
      };
    };
  }, function (e, r) {
    e.exports = function (e, r, t) {
      return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    };
  }, function (e, r, t) {
    var n = t(5);
    e.exports = function (e, r) {
      if (null == e) return {};
      var t,
        o,
        a = n(e, r);
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for (o = 0; o < c.length; o++) t = c[o], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
      }
      return a;
    };
  }, function (e, r, t) {
    "use strict";

    t.r(r);
    var n = t(1),
      o = t.n(n),
      a = t(2),
      c = t.n(a),
      i = t(3),
      l = t.n(i),
      s = t(0),
      p = t.n(s);
    function u(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r && (n = n.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, n);
      }
      return t;
    }
    function f(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        if (r % 2) for (var n = u(Object(t), !0), o = 0; o < n.length; o++) s = n[o], c()(e, s, t[s]);else if (Object.getOwnPropertyDescriptors) Object.defineProperties(e, Object.getOwnPropertyDescriptors(t));else for (var a = u(Object(t)), i = function (r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
          }, l = 0; l < a.length; l++) i(a[l]);
      }
      var s;
      return e;
    }
    var b = Object(s.memo)(function (e) {
      var r = e.activeControlProps,
        t = e.activeTabIndex,
        n = e.activeTabProps,
        a = e.children,
        c = e.controls,
        i = e.controlsWrapperProps,
        u = e.hiddenTabProps,
        b = e.onRequestChange,
        d = e.renderOnlyActiveTab,
        y = e.tabsWrapperProps,
        v = e.wrapperProps,
        O = s.Children.toArray(a),
        P = O[t] ? t : 0;
      return p.a.createElement("div", v, c.length > 0 && p.a.createElement("div", i, function (e) {
        for (var r = e.activeControlProps, t = e.activeTabIndex, n = e.controls, o = e.onRequestChange, a = n, c = function (e, n) {
            var a = e.props || {},
              c = a.tabIndex,
              i = void 0 === c ? n : c,
              s = l()(a, ["tabIndex"]),
              p = e.key || i,
              u = i === t,
              b = s.className || "",
              d = r.className || "",
              y = "".concat(b, " ").concat(u ? d : ""),
              v = s.style || {},
              O = r.style || {},
              P = f({}, v, {}, u ? O : {}),
              m = f({}, s, {}, u ? r : {}, {
                className: y,
                style: P,
                onClick: function (e) {
                  o(i), s.onClick && s.onClick(e);
                }
              });
            return f({}, e, {
              props: m,
              key: p
            });
          }, i = [], s = 0; s < a.length; s++) i.push(c(a[s], s));
        return i;
      }({
        activeControlProps: r,
        activeTabIndex: P,
        controls: c,
        onRequestChange: b
      })), O.length > 0 && p.a.createElement("div", y, function (e) {
        for (var r = e.activeTabIndex, t = e.activeTabProps, n = e.hiddenTabProps, a = e.renderOnlyActiveTab, c = e.tabs, i = function (e, c) {
            var i = e.key || c,
              l = c === r;
            if (a && !l) return o()(s.Fragment, {}, i);
            var p = e.props || {},
              u = p.className || "",
              b = t.className || "",
              d = n.className || "",
              y = "".concat(u, " ").concat(l ? b : d),
              v = p.style || {},
              O = t.style || {},
              P = n.style || {},
              m = f({}, v, {}, l ? O : P),
              g = f({}, p, {}, l ? t : n, {
                className: y,
                style: m
              });
            return f({}, e, {
              props: g,
              key: i
            });
          }, l = [], p = 0; p < c.length; p++) l.push(i(c[p], p));
        return l;
      }({
        activeTabIndex: P,
        activeTabProps: n,
        hiddenTabProps: u,
        renderOnlyActiveTab: d,
        tabs: O
      })));
    });
    b.defaultProps = {
      activeControlProps: {},
      activeTabIndex: 0,
      activeTabProps: {},
      children: null,
      controls: [],
      controlsWrapperProps: {},
      hiddenTabProps: {
        style: {
          display: "none"
        }
      },
      renderOnlyActiveTab: !1,
      tabsWrapperProps: {},
      wrapperProps: {}
    }, r.default = b;
  }, function (e, r) {
    e.exports = function (e, r) {
      if (null == e) return {};
      var t,
        n,
        o = {},
        a = Object.keys(e);
      for (n = 0; n < a.length; n++) t = a[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
      return o;
    };
  }]);
});